"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OtherIncomeTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "othinc-1",
    question: "Has the entity entered into any lease agreement as the lessor?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "othinc-2",
      question: "What is the nature of the agreement(s) entered into?",
      type: "radio",
      options: ["Finance Lease", "Operating Lease", "Both"],
    },
  },
];

export default function OtherIncomeTailoringQuestions({ onBack }: OtherIncomeTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Income"
      title="Other Income - Tailoring Questions"
      description="Customize the program for Other Income."
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}


